import { CheckTaskProps, CongestionProps } from 'src/components/SiteCoreCheckTask';

export function isCongestionCheck(checkTask?: CheckTaskProps): checkTask is CongestionProps {
  return typeof checkTask !== 'undefined' && checkTask?.type === 'congestion';
}
